import { render } from "./Section1.vue?vue&type=template&id=759a62f6"
import script from "./Section1.vue?vue&type=script&lang=js"
export * from "./Section1.vue?vue&type=script&lang=js"
script.render = render

export default script